import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector, useDispatch } from 'react-redux';
import { getSettings } from '../../util/getSettings';
import { Filters } from '../../util/constants';
import { setSelectedCity, setRelativeUrl, setSelectedMetro } from '../../redux/actions/mobileLocationFilters';

const CityFilterDropdown = () => { 
  const dropdownId = `${Filters.CITY_FILTER}_DROPDOWN`
  const labels = getSettings(['century', 'labels'], true);
  const mobileLocFilters = useSelector((state) => state.mobileLocFilters);
  const dispatch = useDispatch()

  const onSelectChange = (cityId) => {
    const selectedCity = mobileLocFilters.cities.find((city) => city.ContentId == cityId);
    dispatch(setRelativeUrl(selectedCity.RelativeURL));
    dispatch(setSelectedCity(selectedCity.CityName));
    dispatch(setSelectedMetro(selectedCity.MetroName));
  }

  return (
    <div className="dropdown">
      <label className="filter-title">{labels.cityFilterLabel}</label>
      <Dropdown onSelect={onSelectChange}>
        <Dropdown.Toggle variant="success" id="dropdown-basic" aria-controls={dropdownId}>
          {mobileLocFilters.selectedCity.length ? mobileLocFilters.selectedCity : 'Select City'}
        </Dropdown.Toggle>
        <Dropdown.Menu id={dropdownId}>
          {mobileLocFilters.cities.map((city, index) => (
              <Dropdown.Item key={index} eventKey={city.ContentId}>
                {city.CityName}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default CityFilterDropdown;